import { Record } from 'immutable';

import {
  REQUEST_CASINO_CONTROLS,
  SET_CASINO_CONTROLS,
  SET_CASINO_CONTROLS_ERRORS,
  CLEAR_CASINO_CONTROLS_ERRORS,
  UPDATE_CASINO_LOSS_LIMIT,
  UPDATE_CASINO_LOSS_LIMIT_SUCCESS,
  UPDATE_CASINO_LOSS_LIMIT_ERROR,
  UPDATE_CASINO_REALITY_CHECK,
  UPDATE_CASINO_REALITY_CHECK_SUCCESS,
  UPDATE_CASINO_REALITY_CHECK_ERROR,
} from './actions';

const InitialState = new Record({
  lossLimitAmount: null,
  lossLimitPeriodDays: null,
  // lossLimitRemaining: null,
  realityCheckMinutes: null,
  loading: true,
  error: '',
  editState: 'initial',
  editError: '',
});

const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUEST_CASINO_CONTROLS: {
      return state
        .set('loading', true)
        .set('error', '');
    }
    case SET_CASINO_CONTROLS: {
      return state
        .set('lossLimitAmount', payload.lossLimit.amount)
        .set('lossLimitPeriodDays', payload.lossLimit.periodDays)
        .set('realityCheckMinutes', payload.realityCheckMinutes)
        .set('loading', false);
    }
    case SET_CASINO_CONTROLS_ERRORS: {
      return state
        .set('error', payload)
        .set('loading', false);
    }
    case CLEAR_CASINO_CONTROLS_ERRORS: {
      return state
        .set('error', '')
        .set('editState', 'initial')
        .set('editError', '');
    }
    case UPDATE_CASINO_LOSS_LIMIT: {
      // still under dev, future proofing it
      return state
        .set('editError', '')
        .set('editState', 'loading');
    }
    case UPDATE_CASINO_LOSS_LIMIT_SUCCESS: {
      // still under dev, future proofing it
      return state
        .set('lossLimitAmount', payload.lossLimit.amount)
        .set('lossLimitPeriodDays', payload.lossLimit.periodDays)
        .set('editState', 'success');
    }
    case UPDATE_CASINO_LOSS_LIMIT_ERROR: {
      // still under dev, future proofing it
      return state
        .set('editError', payload)
        .set('editState', 'error');
    }
    case UPDATE_CASINO_REALITY_CHECK: {
      return state
        .set('editError', '')
        .set('editState', 'loading');
    }
    case UPDATE_CASINO_REALITY_CHECK_SUCCESS: {
      return state
        .set('realityCheckMinutes', payload.periodMinutes)
        .set('editState', 'success');
    }
    case UPDATE_CASINO_REALITY_CHECK_ERROR: {
      return state
        .set('editError', payload)
        .set('editState', 'error');
    }
    default:
      return state;
  }
};
